import { Component, Input } from '@angular/core';

@Component({
  selector: 'rr-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
})
export class InfoIconComponent {
  @Input() className: string;
  @Input() tooltipText: string;

  constructor() {}
}
